import { baseUrl } from '@/service/util';
import request from '@/utils/request';

// 根据zipCode或者地理定位获取门店
export const getGeoStores = (params: any, locale: string) => {
    return request.get(`${baseUrl(locale)}/dp3/queryByZipCode`, {
        params,
    });
};
